import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { selectOrg, setOrg } from '../../../redux/orgSlice'
import { useEffect } from 'react'
import { SCHOOL_LOADING_ERROR_CODES } from '../../../components/LoadingSpinner/loadingErrorCodes'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import { logger } from '../../../helpers/logger'
import CentreListeners from './listeners/CentreListeners'
import { Stack } from '@mui/material'
import CentreHeader from '../../../components/Header/CentreHeader'

export const ECCLayout = () => {
    const { centreId } = useParams()
    const org = useSelector(selectOrg)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!centreId || org?.id === centreId) return
        dispatch(
            setOrg({
                id: centreId,
                type: 'childcareCentre',
            })
        )
    }, [dispatch, org, centreId])

    if (!centreId || !org || org.id !== centreId) {
        logger.debug(centreId, org)
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                id="school-layout-orgCheck"
                errorCode={SCHOOL_LOADING_ERROR_CODES.SCHOOL_LAYOUT.code}
            />
        )
    }

    return (
        <>
            <CentreListeners centreId={org.id} />
            <Stack
                sx={{ height: '100%', minHeight: '100vh', overflow: 'hidden' }}
            >
                <CentreHeader centreId={org.id} />
                <Stack
                    style={{ display: 'flex', flex: 1 }}
                    alignItems={'center'}
                    justifyContent={'center'}
                >
                    <Outlet />
                </Stack>
            </Stack>
        </>
    )
}
